var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',{attrs:{"title":"Upload Logo"}},[_c('image-manager',{ref:"logoManager",on:{"upload":_vm.uploadLogo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }